import { getFirestore, collection, addDoc, getDocs, deleteDoc, doc, query, where } from 'firebase/firestore';
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());
const genresCollection = collection(db, 'genres');

export async function addGenreToFirestore(name, uid) {
  const docRef = await addDoc(genresCollection, { name, uid });
  return docRef.id;
}

export async function getGenresFromFirestore(uid) {
  let q = genresCollection;
  if (uid) {
    q = query(genresCollection, where('uid', '==', uid));
  }
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

export async function deleteGenreFromFirestore(id) {
  await deleteDoc(doc(genresCollection, id));
}
